import defaultTheme from './defaultTheme';
const rakutenTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#5744A0', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#5744A0', background: '#5744A0' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#5744A0' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#5744A0', border: '#5744A0', background: '#5744A0' }), field: {
        focus: '#5744A0',
        label: '#5744A0',
        icon: '#5744A0',
    } });
export default rakutenTheme;
